import React, { useState } from "react";
import react, { FC } from "react";
import { NavDropdown } from "react-bootstrap";
import { DropdownSubmenu, NavDropdownMenu } from "react-bootstrap-submenu";
import { useDispatch } from "react-redux";
import { startApplyRule } from "../../../../actions/ruleAction";
import { ActionModel } from "../../../../models/actionModel";
import { NavigationDropdownList } from "../../../../models/NavgationDropdownModel";

export interface NavDropdownProps{
  index :string;
  element :NavigationDropdownList[];
  actions: ActionModel[];
}

const NavigationDropdown:FC<NavDropdownProps> = ({index, element, actions}) =>{
  const dispatch = useDispatch();
  const [onClickActions, setOnClickActions] = useState(
    actions.filter((action) => {
      return action.actionType === "onClick";
    })
  );

  async function OnClickActions(dropdownId: String) {
    await Promise.all(
      onClickActions
        .map(async (action) => {
          if(action.dropdownLvl1 == dropdownId || action.dropdownLvl2 == dropdownId || action.dropdownLvl3 == dropdownId){
              dispatch(startApplyRule(action));
          }
        })
    );
  }
  const DropdownRender = element.map((drpdwn=>{
    return (
        drpdwn.isDropdown ?
           <DropdownSubmenu  title={drpdwn.name.toString()} className={"dropdown-submenu-container"}>
            <NavigationDropdown index={index} element={drpdwn.dropdown} actions={actions}/>
           </DropdownSubmenu> :
        <NavDropdown.Item id={drpdwn.id} onClick={()=>{OnClickActions(drpdwn.id)}}>{drpdwn.name}</NavDropdown.Item>
    )
  }))

    return(
      <div>
        {DropdownRender}
      </div>
    );
}


export default NavigationDropdown;